module.exports = __webpack_public_path__ + "static/media/bgMobile.61d34d54.jpg";